/**
 * Returns true when a score change causes the worker to become newly restricted
 * (i.e., the post-penalty score drops to ≤ 0 while the pre-penalty score was > 0).
 *
 * @param currentScore - The score **after** the penalty has been applied (e.g., -10).
 * @param scoreChange  - The penalty delta, which is negative (e.g., -40).
 *                        `currentScore - scoreChange` reverses the penalty to recover the pre-penalty score.
 */
export function isBecomingRestricted(currentScore: number, scoreChange: number): boolean {
  return currentScore <= 0 && currentScore - scoreChange > 0;
}
